import {http} from '@/helpers/http-helper';

class QueryIssueType {
    constructor(uuid, username, date, description, active,) {
        this.uuid = uuid;
        this.username = username;
        this.date = date;
        this.description = description;
        this.active = active;
    }
}

export const getQueryIssueTypes = () => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/issue-types';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let queryIssueTypes = [];

                    response.data.forEach((queryIssueType) => {
                        queryIssueTypes.push(
                            new QueryIssueType(
                                queryIssueType.uuid,
                                queryIssueType.user.username,
                                new Date(queryIssueType.createdAt),
                                queryIssueType.description,
                                queryIssueType.active)
                        );
                    });

                    resolve(queryIssueTypes);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createQueryIssueType = (newQueryIssueType) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/issue-types';
        http.post(url, newQueryIssueType)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateQueryIssueType = (queryIssueType) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/issue-types/' + queryIssueType.uuid;
        http.post(url, queryIssueType)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQueryIssueType = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/issue-types/' + uuid;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteQueryIssueType = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/issue-types/' + uuid;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};